// extracted by mini-css-extract-plugin
export default {"loadingIndicator":"loading-indicator__loading-indicator__NPVuZ"};